import { DataEntryVehicleStepSectionPropsWithStep, typedMemo } from "src/types";
import { FormRow, InputText, InputUploadFile } from "src/ui/widgets";
import { useDataEntryVehicleStepVehicleDamages } from "./vehicle-step-vehicle-damages.hook";
import { TEXTAREA_MAX_LENGTH } from "src/config";
import { VehicleImpactPointsGrid } from "./vehicle-impact-points-grid";

export const DataEntryVehicleStepVehicleDamages = typedMemo(
  (props: DataEntryVehicleStepSectionPropsWithStep) => {
    const {
      step,
      formikFieldBaseName,
      formikVehicleValues,
      formikVehicleErrors,
      formikVehicleTouched,
      formik,
      validationSchema,
    } = props;

    const {
      vehicleTypeDamagesLetter,
      documents,
      t,
      handleUploadFile,
      handleDeleteFile,
      handleDocumentsAdded,
      handleDocumentRemoved,
    } = useDataEntryVehicleStepVehicleDamages(props);

    const { handleChange, handleBlur } = formik;

    const VehicleDamagesImage = (
      <div className="text-center text-lg-start">
        <div className="label-l mb-2 mt-lg-2 mt-3">
          {t("data_entry.vehicle_step.section_vehicle_damages_vehicle_image")}
        </div>
        <div className="d-flex justify-content-center justify-content-lg-start">
          <VehicleImpactPointsGrid
            step={step}
            formikFieldBaseName={formikFieldBaseName}
            formikVehicleValues={formikVehicleValues}
            formikVehicleTouched={formikVehicleTouched}
            formikVehicleErrors={formikVehicleErrors}
            formik={formik}
            validationSchema={validationSchema}
          />
        </div>
        {formikVehicleTouched?.vehicleDamages?.impactPoints && (
          <div className="c-error label-l mt-2">
            {formikVehicleErrors?.vehicleDamages?.impactPoints}
          </div>
        )}
      </div>
    );

    const UploadFiles = (
      <>
        <div className="label-l mb-2 mt-md-2 mt-5">
          {t(
            "data_entry.vehicle_step.section_vehicle_damages_vehicle_upload_files",
          )}
        </div>
        <InputUploadFile
          documents={documents}
          onDocumentsAdded={handleDocumentsAdded}
          onDocumentRemoved={handleDocumentRemoved}
          onUploadFile={handleUploadFile}
          onDeleteFile={handleDeleteFile}
        />
      </>
    );

    return (
      <>
        <FormRow
          full_row
          firstField={
            <InputText
              name={`${formikFieldBaseName}.vehicleDamages.notes`}
              textarea
              maxLength={TEXTAREA_MAX_LENGTH}
              handleChange={handleChange}
              handleBlur={handleBlur}
              validationSchema={validationSchema}
              touched={formikVehicleTouched?.vehicleDamages?.notes}
              value={formikVehicleValues.vehicleDamages?.notes}
              error={formikVehicleErrors?.vehicleDamages?.notes}
              label={`${t("data_entry.vehicle_step.section_vehicle_damages", { vehicle: vehicleTypeDamagesLetter })}`}
              placeholder={t("commons.insert")}
            />
          }
        />

        <FormRow
          firstField={VehicleDamagesImage}
          secondField={UploadFiles}
          bp_layout="lg"
        />
      </>
    );
  },
);
